export const BREAKPOINTS = {
  phone: 320,
  tablet: 768,
  desktop: 1024,
  desktopMedium: 1200,
  desktopXXL: 3000,
}